exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-upload .avatar[data-v-675238a7] {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.flex[data-v-675238a7] {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 10px;\n}\n.flex .el-form-item[data-v-675238a7] {\n  margin-bottom: 0;\n}\n", ""]);

// exports
